import { Checkmark, Warning } from '@clearkit/icons';
import classnames from 'classnames';
import { CKButton } from 'clearkit';

import { useProfilePermissions } from '~/components/profile/useProfilePermissions';
import { GridList } from '~/components/unified/GridList';
import { AccountApiVersions, ApiVersion } from '~/generated/graphql';

import { VersionedAPIType } from './types';

type APIVersionsListProps = {
  apiVersions: AccountApiVersions;
  onUpgrade: (apiName: VersionedAPIType) => void;
};
export const APIVersionsList = ({
  onUpgrade,
  apiVersions,
}: APIVersionsListProps) => {
  const handleUpdate = (apiName: VersionedAPIType) => {
    onUpgrade(apiName);
  };

  return (
    <GridList gridTemplateColumns="1fr 1fr 1fr 6rem">
      <GridList.Header className="px-8">
        <div>API Name</div>
        <div>Current Version</div>
        <div>Your Version</div>
      </GridList.Header>
      {apiVersions ? (
        <>
          <APIVersionItem
            name="person"
            onUpgrade={handleUpdate}
            version={apiVersions.person}
          />
          <APIVersionItem
            name="company"
            onUpgrade={handleUpdate}
            version={apiVersions.company}
          />
          <APIVersionItem
            name="prospector"
            onUpgrade={handleUpdate}
            version={apiVersions.prospector}
          />
          <APIVersionItem
            name="watchlist"
            onUpgrade={handleUpdate}
            version={apiVersions.watchlist}
          />
          <APIVersionItem
            name="risk"
            onUpgrade={handleUpdate}
            version={apiVersions.risk}
          />
          <APIVersionItem
            name="reveal"
            onUpgrade={handleUpdate}
            version={apiVersions.reveal}
          />
        </>
      ) : null}
    </GridList>
  );
};

type APIVersionItemProps = {
  name: VersionedAPIType;
  version: ApiVersion;
  onUpgrade: (apiName: VersionedAPIType) => void;
};
function APIVersionItem({ version, name, onUpgrade }: APIVersionItemProps) {
  const { isOwner } = useProfilePermissions();
  const isCurrent = version.current === version.latest;

  return (
    <GridList.Item
      className={classnames('px-8 pt-4', {
        'bg-yellow-0': !isCurrent,
      })}
      key={name}
    >
      <div className="flex items-center gap-2">
        {isCurrent ? (
          <Checkmark className="text-green" />
        ) : (
          <Warning className="text-yellow-600" />
        )}
        <span className="capitalize">{name} API</span>
      </div>
      <div>{version.latest}</div>
      <div>{version.current}</div>
      <div className="flex justify-end">
        {!isCurrent ? (
          <CKButton
            isDisabled={!isOwner}
            onClick={() => onUpgrade(name)}
            variant="bold"
            variantColor="blue"
          >
            Upgrade
          </CKButton>
        ) : null}
      </div>
    </GridList.Item>
  );
}
